import upArrow from "assets/images/organisationProfile/setup/select arrow.svg";
import upArrowdark from "assets/images/organisationProfile/setup/selectArowdark.svg";
import React, { useEffect, useRef, useState } from "react";
// import GetActionIcon from "constants/Homepage/ysafe/iconFunctions/getActionIcon";
import useTheme from "hooks/observer";
import SquareCheckBox from "components/SquareCheckBox/index";
import "./roleOperations.scss";
import Button from "components/Button/index";
import { listPermissions } from "@induz/sdk";

const RoleOperation = ({ updateOperations, initialOperations,handleKeyDown }) => {
  const theme = useTheme();
  const arrow = theme === "light" ? upArrow : upArrowdark;

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [hasSelectionBeenConfirmed, setHasSelectionBeenConfirmed] = useState(
    !!initialOperations?.length
  );

  const dropdownRef = useRef(null);
  

  // TODO: Fetch operations from API instead of static data
  // Example: fetchOperations().then(data => setDropdownData(data));
  const perms = listPermissions();
  const dropdownData = perms
    .filter((perm) => perm !== "RestoreVersion")
    .map((perm) => ({ role: perm }));

  const [checkedStates, setCheckedStates] = useState(
    dropdownData.map(
      (op) => initialOperations?.some((o) => o.role === op.role) || false
    )
  );

  const handleCheckboxChange = (index) => {
    const newCheckedStates = [...checkedStates];
    newCheckedStates[index] = !newCheckedStates[index];
    
    setCheckedStates(newCheckedStates);
  };

  const truncateName = (name) => {
    const parts = name.split(" ");
    if (parts.length > 1) {
      return `${parts[0]} ${parts[1].charAt(0)}...`;
    }
    return name.length > 8 ? `${name.substring(0, 8)}...` : name;
  };

  const selectedRoles = dropdownData.filter((_, index) => checkedStates[index]);

  const filteredDropdownData = dropdownData.filter((role) =>
    role.role.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const renderSelectedRoles = () => (
    <div className="selected-users-container">
      {!hasSelectionBeenConfirmed ? (
        <>
          <input
            type="text"
            placeholder="Select operations"
            className="user-input"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onFocus={() => setIsDropdownOpen(true)}
            onKeyDown={handleKeyDown}
          />
          <img
            src={arrow}
            alt="arrow"
            className="dropdown-arrow"
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          />
        </>
      ) : (
        <>
          <div className="user-chips">
            {selectedRoles.slice(0, 2).map((role, index) => (
              <span key={index} className="user-chip">
                {truncateName(role.role)}
              </span>
            ))}
            {selectedRoles.length > 2 && (
              <span className="remaining-count">
                +{selectedRoles.length - 2}
              </span>
            )}
          </div>
          <div
            className="cross"
            onClick={() => {
              setCheckedStates(Array(dropdownData.length).fill(false));
              setSearchTerm("");
              setHasSelectionBeenConfirmed(false);
              updateOperations([]);
            }}
          >
            {/* <GetActionIcon
              type="cross"
              color={theme === "light" ? "#7D708A" : "#BDB8C2"}
            /> */}
            <img
              src={arrow}
              alt="arrow"
              className="dropdown-arrow"
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            />
          </div>
        </>
      )}
    </div>
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="RoleOperation">
      <div className="RoleOperationWrapper">
        <div className="RoleOperationWrapperContent" ref={dropdownRef}>
          <p>Add Operations</p>
          <div className="RoleOperationselectUser">
            <div className="user" onClick={() => setIsDropdownOpen(true)}>
              {renderSelectedRoles()}
            </div>
            {isDropdownOpen && (
              <div className="OperationDropdown">
                <ul>
                  {filteredDropdownData.map((option, index) => {
                    const originalIndex = dropdownData.findIndex(
                      (op) => op.role === option.role
                    );
                    return (
                      <li
                        key={option.role}
                        className="NotificationItem"
                        onClick={() => handleCheckboxChange(originalIndex)}
                      >
                        <SquareCheckBox
                          labelStyles={{
                            color: "var(--text-grey-strong)",
                            fontFamily: "helvetica, sans-serif"
                          }}
                          isChecked={checkedStates[originalIndex]}
                          handleCheck={() =>
                            handleCheckboxChange(originalIndex)
                          }
                        />
                        <div className="content">
                          <p>{option.role}</p>
                        </div>
                      </li>
                    );
                  })}
                </ul>
                <div className="OperationDropdownButtons">
                  <Button
                    type="white"
                    title="Clear"
                    width="50%"
                    onClick={() => {
                      setCheckedStates(Array(dropdownData.length).fill(false));
                      setSearchTerm("");
                      setHasSelectionBeenConfirmed(false);
                      updateOperations([]);
                    }}
                  />
                  <Button
                    type="violet"
                    title="Select"
                    width="50%"
                    onClick={() => {
                      setIsDropdownOpen(false);
                      setHasSelectionBeenConfirmed(true);
                      updateOperations(selectedRoles);
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoleOperation;
